import { object, ObjectSchema, string } from 'yup';

import { SecurityType, SecurityValue } from '@client/api';

import { moneyValueSchema } from './MoneyValue.schema';

const schema: ObjectSchema<SecurityValue> = object({
  type: string<SecurityType>()
    .oneOf(['BankDeposit', 'BankGuarantee', 'Cash', 'Other'])
    .required()
    .label('SecurityType'),
  amount: moneyValueSchema,
});

export { schema as securityValueSchema };
